import { CustomSettingGuard } from '@components/customSettingGuard';
import { ProtectedRoute } from '@components/protectedRoute';
import { InventoryProvider } from '@contexts/inventory';
import { InventoryQuantitiesProvider } from '@contexts/inventory/quantities';
import { appRoutes } from '@utils/consts';
import { parseRoute } from '@utils/i18n';

export const inventoryRoutes = [
  {
    path: appRoutes.inventory,
    lazy: async () => {
      const { Inventory } = await import('@pages/inventory');
      return {
        Component: () => (
          <ProtectedRoute>
            <CustomSettingGuard
              disabledBy="inventory_module_disabled"
              redirectTo={parseRoute(appRoutes.index)}>
              <InventoryProvider>
                <InventoryQuantitiesProvider>
                  <Inventory />
                </InventoryQuantitiesProvider>
              </InventoryProvider>
            </CustomSettingGuard>
          </ProtectedRoute>
        ),
      };
    },
  },
];
